export default __webpack_public_path__ + "static/media/d745ca0a.svg";